import {
  IconArrowLeft,
  IconClockHour2,
  IconDotsVertical,
  IconMicrophone,
  IconMoodHappyFilled,
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
  IconPlus,
  IconSearch,
  IconSend2,
  IconStar,
} from "@tabler/icons-react";
import { useState } from "react";

interface Message {
  sender: "me" | "them";
  text?: string;
  voice?: boolean;
  duration?: string;
  time: string;
}

interface Contact {
  name: string;
}

interface SidebarProps {
  contacts: Contact[];
  selectContact: (name: string) => void;
}

export default function ChatSupportListTab() {
  const [selectedContact, setSelectedContact] = useState<string | null>(null);

  const messages: Message[] = [
    {
      sender: "them",
      text: "Oh, hello! All perfectly.\nI will check it and get back to you soon",
      time: "04:45 PM",
    },
    {
      sender: "me",
      text: "Oh, hello! All perfectly.\nI will check it and get back to you soon",
      time: "04:45 PM",
    },
    {
      sender: "them",
      text: "Oh, hello! All perfectly.\nI will check it and get back to you soon",
      time: "04:45 PM",
    },
    {
      sender: "me",
      text: "Oh, hello! All perfectly.\nI will check it and get back to you soon",
      time: "04:45 PM",
    },
    { sender: "them", voice: true, duration: "01:24", time: "04:45 PM" },
  ];

  const contacts: Contact[] = [
    { name: "Jennifer Markus" },
    { name: "Iva Ryan" },
    { name: "Jerry Helfer" },
    { name: "David Elson" },
    { name: "Mary Freund" },
    { name: "Mariya Jhon" },
  ];

  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
    // Here you can also handle actual audio playing logic if needed
  };

  return (
    <div className="flex h-[calc(100vh-11rem)] overflow-hidden bg-[#F7F6F2] rounded-[20px]">
      {/* Sidebar */}
      <div
        className={`flex-col w-full md:w-96 border-r  border-[#d2d2d2] ${
          selectedContact && "hidden md:flex"
        }`}
      >
        <Sidebar contacts={contacts} selectContact={setSelectedContact} />
      </div>

      {/* Chat Area */}
      <div
        className={`flex-1 flex flex-col ${
          !selectedContact && "hidden md:flex"
        }`}
      >
        {selectedContact ? (
          <>
            {/* Header */}
            <div className="flex items-center justify-between py-[18px] px-4 border-b border-[#d2d2d2]">
              <div className="flex items-center space-x-3">
                {/* Back button on mobile */}
                <button
                  onClick={() => setSelectedContact(null)}
                  className="md:hidden"
                >
                  <IconArrowLeft className="w-5 h-5 text-gray-600" />
                </button>
                <div className="w-10 h-10 rounded-lg">
                  <img
                    src="\img\dumy-profile.png"
                    className="rounded-lg object-cover"
                    alt=""
                  />{" "}
                </div>
                <span className="font-medium">{selectedContact}</span>
              </div>
              <div className="hidden md:flex items-center space-x-4">
                <IconStar className="w-5 h-5 text-[#FBD037]" />
                <IconSearch className="w-5 h-5 text-gray-600" />
                <IconDotsVertical
                  stroke={3}
                  className="w-5 h-5 text-gray-600"
                />
              </div>
            </div>

            {/* Messages */}
            <div className="flex-1 p-4 md:p-6 overflow-y-auto space-y-6">
              <div className="text-xs text-gray-400 text-center">
                Today | 06:32 PM
              </div>

              {messages.map((msg, idx) => (
                <div
                  key={idx}
                  className={`flex ${
                    msg.sender === "me" ? "justify-end" : "justify-start"
                  }`}
                >
                  <div
                    className={`max-w-xs md:max-w-md px-4 py-3  text-sm whitespace-pre-line ${
                      msg.sender === "me"
                        ? "bg-[#FBD037] text-black rounded-l-3xl rounded-t-3xl"
                        : "bg-gray-100 text-black rounded-r-3xl rounded-t-3xl"
                    }`}
                  >
                    {msg.voice ? (
                      // <div className="flex items-center">
                      //   <div className="w-28 h-10 bg-[#FBD037] rounded-full flex items-center justify-center">
                      //     <div className="w-20 h-2 bg-yellow-500 rounded-md"></div>
                      //   </div>
                      //   <span className="ml-2 text-xs">{msg.duration}</span>
                      // </div>

                      <div className="flex items-center space-x-2">
                        <button
                          onClick={togglePlay}
                          className="p-2 bg-[#FBD037] rounded-full text-black flex items-center justify-center"
                        >
                          {isPlaying ? (
                            <IconPlayerPauseFilled size={18} />
                          ) : (
                            <IconPlayerPlayFilled size={18} />
                          )}
                        </button>

                        {/* Waveform */}
                        <div className="flex items-center bg-[#FBD037] rounded-2xl px-4 py-2">
                          <div className="flex items-center space-x-1">
                            {[6, 10, 14, 10, 6, 12, 8, 14, 6].map(
                              (height, idx) => (
                                <div
                                  key={idx}
                                  className="w-0.5 bg-black rounded-full"
                                  style={{ height: `${height}px` }}
                                ></div>
                              )
                            )}
                          </div>
                        </div>
                        <span className="text-xs text-black">
                          {msg.duration}
                        </span>
                      </div>
                    ) : (
                      <p>{msg.text}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="flex items-center gap-4 p-4 border-t border-[#d2d2d2]">
              <IconMoodHappyFilled size={34} className="text-[#FBD037]" />
              <div className="relative flex items-center w-full">
                <span className="absolute left-4 bg-yellow-400 p-0.5 rounded-full">
                  <IconPlus stroke={1.5} />
                </span>
                <input
                  type="text"
                  placeholder="Type your message here ..."
                  className="flex-1 pl-14 px-6 py-3 w-full bg-gray-100 rounded-full outline-none text-sm"
                />
              </div>
              <button className="p-3 rounded-full">
                <IconMicrophone className="w-5 h-5 text-[#FBD037]" />
              </button>
              <button className="bg-yellow-400 p-3 rounded-full">
                <IconSend2 className="w-5 h-5 text-[#000]" />
              </button>
            </div>
          </>
        ) : (
          <div className="hidden md:flex flex-1 justify-center items-center text-gray-400">
            Select a chat to start messaging
          </div>
        )}
      </div>
    </div>
  );
}

function Sidebar({ contacts, selectContact }: SidebarProps) {
  return (
    <>
      <div className="flex items-center justify-between px-4 py-6 border-b border-[#d2d2d2]">
        <h2 className="text-lg font-semibold">All Messages</h2>
        <IconDotsVertical stroke={3} className="w-5 h-5 text-gray-600" />
      </div>
      {/* Search */}
      <div className="px-4 py-3">
        <div className="flex items-center bg-gray-100 rounded-lg px-4 py-3">
          <IconSearch className="w-4 h-4 text-[#FBD037] mr-2" />
          <input
            className="bg-transparent outline-none text-sm w-full"
            placeholder="Search or start a new chat"
          />
        </div>
      </div>
      {/* Contacts */}
      <div className="flex-1 overflow-y-auto divide-y divide-[#d2d2d2]">
        {contacts.map((contact, idx) => (
          <div
            key={idx}
            onClick={() => selectContact(contact.name)}
            className="flex justify-between items-center px-4 py-5 hover:bg-[#F8F9FD] cursor-pointer space-x-4"
          >
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 rounded-lg flex-shrink-0">
                <img
                  src="/img/dumy-profile.png"
                  className="rounded-lg object-cover"
                  alt=""
                />{" "}
              </div>
              <div className="space-y-2">
                <div className="font-medium text-sm">{contact.name}</div>
                <div className="text-xs text-black/70">
                  Hey! Did you finish the Hi-FI wireframes for flora app design?
                </div>
                <div className="text-xs text-black/60 flex items-center gap-1">
                  <span>
                    {" "}
                    <IconClockHour2 size={16} />
                  </span>{" "}
                  Today | 05:30 PM
                </div>
              </div>
            </div>
            <button className="bg-yellow-400 h-6 w-6 text-center rounded-full text-xs flex-shrink-0">
              4{" "}
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
